import { useFundsDashcardController } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Investors/Dashcards/useFundsDashcardController';
import {
	TEST_ELEMENT_IDS,
	UIElementIdentifier,
} from '@dealstack/frontend/shared/helper/UIElementIdentifier/UIElementIdentifier';
import { AmountFormatted } from '@dealstack/frontend/shared/components/AmountFormatted/AmountFormatted';
import {
	CHIP_THEME,
	Chips as ChipsV2,
	COLOR,
} from '@dealstack/frontend/shared/components/Chips/Chips.v2';
import { DashCard } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/DashCard/DashCard';
import { Button as ButtonV2 } from '@dealstack/frontend/shared/components/fundament/Button/Button.v2';
import {
	useTranslationCommonUi,
	useTranslationMipManage,
} from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';

interface Props {
	className?: string;
}

export const DashcardFunds = ({ className }: Props) => {
	const tMipManage = useTranslationMipManage();
	const tCommonUi = useTranslationCommonUi();
	const {
		contentValues,
		isSingleInvestmentWorkflow,
		isSomePaymentsPending,
		isSinglePaymentPending,
		showStatusChip,
		onApprovePayment,
		disableApproveButton,
		investorDetailsData,
	} = useFundsDashcardController();

	const showApproveButton = isSingleInvestmentWorkflow
		? isSinglePaymentPending
		: isSomePaymentsPending;
	const isTotalInvestmentZero = contentValues?.value === 0;

	return (
		<DashCard className={className}>
			<DashCard.Top textVariant="sans/14/600" icon="euro">
				{tMipManage('investors.dashcards.funds_title')}
			</DashCard.Top>
			<DashCard.Divider />
			<DashCard.Middle
				content={[
					{
						key: contentValues?.text,
						value: (
							<AmountFormatted
								value={contentValues?.value}
								currency={investorDetailsData?.currency}
								showNegative
							/>
						),
					},
				]}
				status={
					showStatusChip && !isTotalInvestmentZero ? (
						<ChipsV2
							prefixIcon="tick"
							size="s"
							chipTheme={CHIP_THEME.DARK}
							color={COLOR.GREY}
						>
							{tCommonUi(
								`chips.${isSingleInvestmentWorkflow ? 'complete' : 'all_complete'}`
							)}
						</ChipsV2>
					) : null
				}
				button={
					showApproveButton && (
						<UIElementIdentifier
							identifier={
								TEST_ELEMENT_IDS.MIP_MANAGE_INVESTORS_DETAILS_DASHCARD_FUNDS_APPROVE_BUTTON
							}
						>
							<ButtonV2
								size="xs"
								variant="primary"
								icon="tick-circle"
								leftIcon
								buttonTheme="light"
								onClick={onApprovePayment}
								disabled={disableApproveButton}
							>
								{tCommonUi('common_buttons.approve')}
							</ButtonV2>
						</UIElementIdentifier>
					)
				}
			/>
		</DashCard>
	);
};
